module.exports = __webpack_public_path__ + "img/questionnaire.9baee021.png";